module.exports = "../fonts/HelveticaNeueLTW01-55Roman.woff";


//////////////////
// WEBPACK FOOTER
// ./src/main/script/komodo/fonts/HelveticaNeueLTW01-55Roman.woff
// module id = Oqx3
// module chunks = 1